import { create } from 'zustand'
import { dataSlice } from './slices/dataSlice'
import { filterSlice } from './slices/filterSlice'
import { premiumSlice } from './slices/premiumSlice'

// Compose all domain slices into a single store
export const useOfferStore = create((set, get) => ({
  ...dataSlice(set, get),
  ...filterSlice(set, get),
  ...premiumSlice(set, get),
}))

// Re-export all selectors so existing `import { selectX } from '@store/offerStore'` keeps working
export { selectOffers, selectAvailableSupermarkets, selectCategoryCounts, selectHasActiveFilters, selectHasUpcoming, selectScrapedAt, selectTotalCount, selectFilteredCount } from './selectors/offerSelectors'
export { selectComparisonGroups, selectRivalries } from './selectors/rivalrySelectors'
export { selectAHCatalogProducts } from './selectors/premiumSelectors'
